// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"591ff632","455":"092277bb","964":"813aab0f","977":"0c08515b","987":"6ab38cb2"}[chunkId] + ".chunk.js";
};